import { z } from 'zod';
import { centsSchema, idParamSchema, idSchema, isoDateSchema, timestampSchema } from './common.js';
// --- Prévision de trésorerie à 24 mois (lot 10) -------------------------------------------
export const forecastQuerySchema = z.object({
    propertyId: idParamSchema.optional(),
});
export const forecastMonthSchema = z.object({
    monthStart: isoDateSchema,
    incomeCents: centsSchema,
    expenseCents: centsSchema,
    loanPaymentCents: centsSchema,
    netCents: z.number().int(),
    /** `null` : pas de solde réel connu (projection par bien, sans compte bancaire dédié). */
    cumulativeBalanceCents: z.number().int().nullable(),
});
export const negativeCashAlertSchema = z.object({
    monthStart: isoDateSchema,
    balanceCents: z.number().int(),
});
export const lowCoverageAlertSchema = z.object({
    monthStart: isoDateSchema,
    ratio: z.number(),
});
export const chargeDriftAlertSchema = z.object({
    propertyId: idSchema,
    categoryId: idSchema,
    categoryLabel: z.string(),
    year: z.number().int(),
    previousYearCents: centsSchema,
    currentYearCents: centsSchema,
    changeRatio: z.number(),
});
export const forecastAlertsSchema = z.object({
    negativeCash: z.array(negativeCashAlertSchema),
    lowCoverage: z.array(lowCoverageAlertSchema),
    chargeDrift: z.array(chargeDriftAlertSchema),
});
export const forecastResponseSchema = z.object({
    series: z.array(forecastMonthSchema),
    alerts: forecastAlertsSchema,
});
export const advisoryInputSchema = z.object({
    propertyId: idSchema.optional(),
});
export const advisoryResponseSchema = z.object({
    commentary: z.string(),
    generatedAt: timestampSchema,
});
//# sourceMappingURL=forecast.js.map